import { radarScale } from "../helpers/circle";
import { IRadialScaleConfig, SvgElement } from "../types";
import { Scale } from "./Scale";

export class RadialScale extends Scale {
	public config: IRadialScaleConfig;

	constructor(_data, config: IRadialScaleConfig) {
		super(_data, config, "radial");
	}

	paint(width: number, height: number): SvgElement {
		if (this.config.hidden) {
			return null;
		}

		const zebra = this.config.zebra;
		const attribute = this.config.value;
		const realAxis = this.config.showAxis ? this._axis.steps : null;
		const axis = this._axis.steps.map(step => this.point(step));
		const scales = this._data.map(item => item[attribute]);
		const config = { scales, axis, realAxis, zebra, attribute };

		return radarScale(config, width, height);
	}

	point(val: number): number {
		return (val - this._axis.min) / (this._axis.max - this._axis.min);
	}
}
